/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  DiaPriceProvider,
  DiaPriceProviderInterface,
} from "../DiaPriceProvider";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_priceProvidersRepository",
        type: "address",
      },
      {
        internalType: "contract IDIAOracleV2",
        name: "_diaOracle",
        type: "address",
      },
      {
        internalType: "address",
        name: "_stableAsset",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AssetNotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "CanNotSetEthKey",
    type: "error",
  },
  {
    inputs: [],
    name: "FallbackPriceProviderNotSet",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidKey",
    type: "error",
  },
  {
    inputs: [],
    name: "KeyDoesNotMatchSymbol",
    type: "error",
  },
  {
    inputs: [],
    name: "LiquidationProviderAlreadySet",
    type: "error",
  },
  {
    inputs: [],
    name: "LiquidationProviderAssetNotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "LiquidationProviderNotExist",
    type: "error",
  },
  {
    inputs: [],
    name: "MissingETHPrice",
    type: "error",
  },
  {
    inputs: [],
    name: "MissingPriceOrSetup",
    type: "error",
  },
  {
    inputs: [],
    name: "OldPrice",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyUSDPriceAccepted",
    type: "error",
  },
  {
    inputs: [],
    name: "PriceCanNotBeFoundForProvidedKey",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "key",
        type: "string",
      },
    ],
    name: "AssetSetup",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "contract IPriceProvider",
        name: "liquidationProvider",
        type: "address",
      },
    ],
    name: "LiquidationProvider",
    type: "event",
  },
  {
    inputs: [],
    name: "DIA_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DIA_ORACLEV2",
    outputs: [
      {
        internalType: "contract IDIAOracleV2",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ETH_USD_KEY",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EXPECTED_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USD_ASSET",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getFallbackPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getFallbackProvider",
    outputs: [
      {
        internalType: "contract IPriceProvider",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_key",
        type: "string",
      },
    ],
    name: "getPriceForKey",
    outputs: [
      {
        internalType: "uint128",
        name: "assetPriceInUsd",
        type: "uint128",
      },
      {
        internalType: "bool",
        name: "priceUpToDate",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "keys",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "liquidationProviders",
    outputs: [
      {
        internalType: "contract IPriceProvider",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "_assetPriceInUsd",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "_ethPriceInUsd",
        type: "uint128",
      },
    ],
    name: "normalizePrice",
    outputs: [
      {
        internalType: "uint256",
        name: "assetPriceInEth",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "offChainProvider",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProviderPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProvidersRepository",
    outputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "removeLiquidationProvider",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "contract IPriceProvider",
        name: "_liquidationProvider",
        type: "address",
      },
    ],
    name: "setLiquidationProvider",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "string",
        name: "_key",
        type: "string",
      },
      {
        internalType: "contract IPriceProvider",
        name: "_liquidationProvider",
        type: "address",
      },
    ],
    name: "setupAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_key",
        type: "string",
      },
    ],
    name: "validateKey",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "string",
        name: "_key",
        type: "string",
      },
    ],
    name: "validateSymbol",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type DiaPriceProviderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: DiaPriceProviderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class DiaPriceProvider__factory extends ContractFactory {
  constructor(...args: DiaPriceProviderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "DiaPriceProvider";
  }

  deploy(
    _priceProvidersRepository: string,
    _diaOracle: string,
    _stableAsset: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<DiaPriceProvider> {
    return super.deploy(
      _priceProvidersRepository,
      _diaOracle,
      _stableAsset,
      overrides || {}
    ) as Promise<DiaPriceProvider>;
  }
  getDeployTransaction(
    _priceProvidersRepository: string,
    _diaOracle: string,
    _stableAsset: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _priceProvidersRepository,
      _diaOracle,
      _stableAsset,
      overrides || {}
    );
  }
  attach(address: string): DiaPriceProvider {
    return super.attach(address) as DiaPriceProvider;
  }
  connect(signer: Signer): DiaPriceProvider__factory {
    return super.connect(signer) as DiaPriceProvider__factory;
  }
  static readonly contractName: "DiaPriceProvider";
  public readonly contractName: "DiaPriceProvider";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DiaPriceProviderInterface {
    return new utils.Interface(_abi) as DiaPriceProviderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DiaPriceProvider {
    return new Contract(address, _abi, signerOrProvider) as DiaPriceProvider;
  }
}
